/**
 * SPECIAL ORDER MODAL
 * 
 * Modal for products not in catalog
 */

import React, { useState } from 'react';

const SpecialOrderModal = ({ fixture, onSave, onClose }) => {
  const [data, setData] = useState({
    product_name: '',
    vendor: '',
    estimated_cost: 0,
    lead_time: '',
    notes: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(data);
  };

  if (!fixture) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h2>Special Order Item</h2>
        <p className="modal-subtitle">
          For: {fixture.fixture_label} in {fixture.area_label}
        </p>
        
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-row">
              <div className="form-group">
                <label>Product Name / Description</label>
                <input
                  type="text"
                  value={data.product_name}
                  onChange={(e) => setData({ ...data, product_name: e.target.value })}
                  placeholder="Product name or description"
                  required
                />
              </div>
              
              <div className="form-group">
                <label>Vendor / Source</label>
                <input
                  type="text"
                  value={data.vendor}
                  onChange={(e) => setData({ ...data, vendor: e.target.value })}
                  placeholder="Where to order from"
                />
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label>Estimated Cost ($)</label>
                <input
                  type="number"
                  value={data.estimated_cost}
                  onChange={(e) => setData({ ...data, estimated_cost: parseFloat(e.target.value) || 0 })}
                  placeholder="0"
                  min="0"
                  step="1"
                />
              </div>
              
              <div className="form-group">
                <label>Lead Time</label>
                <input
                  type="text"
                  value={data.lead_time}
                  onChange={(e) => setData({ ...data, lead_time: e.target.value })}
                  placeholder="2-3 weeks"
                />
              </div>
            </div>
            
            <div className="form-group">
              <label>Notes</label>
              <textarea
                value={data.notes}
                onChange={(e) => setData({ ...data, notes: e.target.value })}
                placeholder="SKU, color, size, or other specifications..."
              />
            </div>
          </div>
          
          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-primary">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SpecialOrderModal;
